// extracted by mini-css-extract-plugin
export default {"picture":"Avatar_picture__DJ0j7","chatBubble":"Avatar_chatBubble__jwvCm","active":"Avatar_active__x6kFL"};